
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/requests",
      function () {
        return require("private-next-pages/dashboard/requests/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/requests"])
      });
    }
  